<div class="wysiwyg">
  <h2>Cookies Policy&nbsp;</h2>
  <br/>
  <div>
    <div id="CookieDeclaration">
    </div>
  </div>
</div>